import { ImportButton, QuizFilters } from 'components/Quizzes/Controls';
import QuizList from 'components/Quizzes/QuizList';
import { useTranslation } from 'react-i18next';
import { Container, Stack, Text } from 'shell/components';

const Desktop = ({ device = 'desktop' }) => {
    const { t } = useTranslation('quiz');

    return (
        <Container device={device}>
            <Stack sx={{ width: '100%', pb: 5 }} spacing={5}>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'} spacing={4}>
                    <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                        {t('quizzes', 'Quizzes')}
                    </Text>
                    <Stack alignItems={'center'} direction={'row'} spacing={4} sx={{ minWidth: 0 }}>
                        <QuizFilters />
                        <ImportButton />
                    </Stack>
                </Stack>
                <QuizList />
            </Stack>
        </Container>
    );
};

export default Desktop;
